import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { select } from '@ngxs/store';

import { AnalyticsEvent, Permissions } from '@efficiently/models';

import { TestIdDirective } from '@efficiently/client-cdk-test-id';
import { AnalyticsService } from '@efficiently/client-core-analytics';
import { PAGES_ROUTES } from '@efficiently/client-core-routing';
import { PermissionSelectors } from '@efficiently/client-domain-permissions';
import { EffButtonComponent } from '@efficiently/client-ui-kit';

/** The platform header's way into Admin Console, rendered only for a reader who may open it. */
@Component({
	selector: 'ds-admin-console-link',
	templateUrl: './admin-console-link.component.html',
	styleUrl: './admin-console-link.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [EffButtonComponent, TestIdDirective],
})
export class AdminConsoleLinkComponent {
	private readonly analyticsService = inject(AnalyticsService);
	private readonly globalPermissions = select<Permissions[]>(PermissionSelectors.globalPermissions);

	protected readonly isVisible = computed<boolean>(
		() => this.globalPermissions()?.includes(Permissions.AdminConsoleTabView) ?? false,
	);
	protected readonly adminConsoleRoute = PAGES_ROUTES.ORG_ADMIN.fullPath();

	protected trackOpen(): void {
		this.analyticsService.track(AnalyticsEvent.GoToAdminConsole);
	}
}
